import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DictationActivityEvent } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PipelineActivityLogService {
  constructor(private http: HttpClient) {}

  getHistoryByDictation(dictationId: string): Promise<{ data: DictationActivityEvent[] }> {
    return this.http
      .get<{ data: DictationActivityEvent[] }>(
        `${environment.BASE_URL}/ai/web/activity-logs/dictation/${dictationId}`
      )
      .toPromise();
  }

  streamByDictation(dictationId: string): EventSource {
    return new EventSource(
      `${environment.BASE_URL}/ai/web/activity-logs/stream?dictation_id=${dictationId}`
    );
  }

  getHistoryByPatient(patientId: string): Promise<{ data: DictationActivityEvent[] }> {
    return this.http
      .get<{ data: DictationActivityEvent[] }>(
        `${environment.BASE_URL}/ai/web/activity-logs/patient/${patientId}`
      )
      .toPromise();
  }

  streamByPatient(patientId: string): EventSource {
    return new EventSource(
      `${environment.BASE_URL}/ai/web/activity-logs/stream?patient_id=${patientId}`
    );
  }

  getActivityLogs(filters: {
    page?: number;
    limit?: number;
    source?: string;
    level?: string;
    practice_id?: string;
    since?: string;
    patient_name?: string;
    provider_id?: string;
  }): Promise<{
    data: {
      data: DictationActivityEvent[];
      currentPage: number;
      nextPage: number | null;
      previousPage: number | null;
      total: number;
      limit: number;
    };
  }> {
    let params = new HttpParams();
    Object.keys(filters).forEach((key) => {
      const value = (filters as any)[key];
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, value);
      }
    });
    return this.http
      .get<any>(`${environment.BASE_URL}/ai/web/activity-logs`, { params })
      .toPromise();
  }
}
